(function() {
  'use strict';

  // ==================== CONFIG ====================
  var API_BASE = 'https://videoapp.wntg.in/api/videos';
  var BUNNY_CDN = 'https://vz-ff818d5d-5dc.b-cdn.net';
  var SLIDE_COUNT = 3;
  var IMAGE_MS = 4000;
  var CAROUSEL_MS = 2000;
  var SETTLE_DELAY = 350;
  var LONG_PRESS_MS = 300;
  var WHEEL_THROTTLE_MS = 500;

  var STORE_MAP = {
    'indophilia.store': 'indophiliaglobal',
    'indophilia.in': 'indophiliaglobal',
    'indophiliausa.myshopify.com': 'indophiliaglobal',
    'wintage.in': 'wintageindia',
    'wintage-garments.myshopify.com': 'wintageindia',
    'wintagefashion.com': 'wintageglobal',
    'wintage-usa.myshopify.com': 'wintageglobal',
    'talethread.in': 'talethreadindia',
    'talethreadindia.myshopify.com': 'talethreadindia',
    'talethread.com': 'talethreadglobal',
    'talethread.myshopify.com': 'talethreadglobal'
  };

  var ICONS = {
    play: '<svg viewBox="0 0 24 24" fill="white"><polygon points="6,3 20,12 6,21"/></svg>',
    close: '<svg viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.5" stroke-linecap="round"><line x1="6" y1="6" x2="18" y2="18"/><line x1="18" y1="6" x2="6" y2="18"/></svg>',
    muted: '<svg viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round"><path d="M11 5L6 9H2v6h4l5 4V5z"/><line x1="23" y1="9" x2="17" y2="15"/><line x1="17" y1="9" x2="23" y2="15"/></svg>',
    unmuted: '<svg viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round"><path d="M11 5L6 9H2v6h4l5 4V5z"/><path d="M19.07 4.93a10 10 0 010 14.14"/><path d="M15.54 8.46a5 5 0 010 7.07"/></svg>',
    pauseBig: '<svg viewBox="0 0 24 24" fill="white" opacity="0.9"><rect x="6" y="4" width="4" height="16" rx="1"/><rect x="14" y="4" width="4" height="16" rx="1"/></svg>',
    chevUp: '<svg viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 15 12 9 18 15"/></svg>',
    chevDown: '<svg viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>'
  };

  // ==================== GUARDS ====================
  var storeId = STORE_MAP[window.location.hostname];
  if (!storeId) return;

  // ==================== HELPERS ====================
  function xhrGet(url, headers, callback) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    if (headers) { for (var key in headers) { if (headers.hasOwnProperty(key)) xhr.setRequestHeader(key, headers[key]); } }
    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4) {
        if (xhr.status >= 200 && xhr.status < 300) {
          try { callback(JSON.parse(xhr.responseText)); } catch(e) { callback(null); }
        } else { callback(null); }
      }
    };
    xhr.onerror = function() { callback(null); };
    try { xhr.send(); } catch(e) { callback(null); }
  }

  function apiFetch(handle, siblings, callback) {
    var url = API_BASE + '?store=' + storeId + '&handle=' + encodeURIComponent(handle) + '&mode=product';
    if (siblings) {
      url += '&siblings=' + encodeURIComponent(siblings);
    }

    if (window.fetch) {
      window.fetch(url)
        .then(function(r) { return r.json(); })
        .then(function(data) { callback(data); })
        .catch(function() {
          console.error('[shoppable] product request failed');
          xhrGet(url, null, callback);
        });
    } else {
      xhrGet(url, null, callback);
    }
  }

  function apiFetchFeed(callback) {
    var url = API_BASE + '?store=' + storeId + '&mode=feed';

    if (window.fetch) {
      window.fetch(url)
        .then(function(r) { return r.json(); })
        .then(function(data) { callback(data); })
        .catch(function() {
          console.error('[shoppable] feed request failed');
          xhrGet(url, null, callback);
        });
    } else {
      xhrGet(url, null, callback);
    }
  }

  function getThumbnailFromBunny(video) {
    if (video.thumbnail_url) return video.thumbnail_url;
    var match = video.bunny_url && video.bunny_url.match(/b-cdn\.net\/([^/]+)\//);
    if (match) return BUNNY_CDN + '/' + match[1] + '/thumbnail.jpg';
    return '';
  }

  function resolveThumbnail(video) {
    var mediaType = video.media_type;
    var thumb = '';
    var first;

    if (mediaType === 'carousel') {
      first = video.media_items && video.media_items.length ? video.media_items[0] : null;
      if (first) {
        thumb = first.thumbnail_url || first.url || video.thumbnail_url || '';
      } else {
        thumb = video.thumbnail_url || '';
      }
    } else if (mediaType === 'image') {
      thumb = video.image_url || video.thumbnail_url || '';
    } else {
      thumb = getThumbnailFromBunny(video);
    }

    return thumb || '';
  }

  function createPlayIcon() {
    var tmp = document.createElement('div');
    tmp.innerHTML = ICONS.play;
    var svg = tmp.firstChild;
    if (svg && svg.setAttribute) svg.setAttribute('class', 'shoppable-tile-play');
    return svg;
  }

  function sizedThumb(url) {
    if (!url) return url;
    if (url.indexOf('wintage-assets.b-cdn.net') === -1) return url;
    if (url.indexOf('?') !== -1) return url;
    return url + '?width=300';
  }

  function buildTile(video) {
    var thumb = sizedThumb(resolveThumbnail(video));
    if (!thumb) return null;

    var mediaType = video.media_type || '';
    var tile = document.createElement('div');
    tile.className = 'shoppable-tile';
    tile.setAttribute('data-video-id', video.id || '');
    tile.setAttribute('data-media-type', mediaType);

    var img = document.createElement('img');
    img.src = thumb;
    img.alt = '';
    img.setAttribute('loading', 'lazy');
    img.onerror = function() {
      if (this.parentNode && this.parentNode.parentNode) {
        this.parentNode.parentNode.removeChild(this.parentNode);
      }
    };
    tile.appendChild(img);

    if (mediaType === 'video') {
      var playIcon = createPlayIcon();
      if (playIcon) tile.appendChild(playIcon);
    }

    return tile;
  }

  function fillMount(mount) {
    var handle = mount.getAttribute('data-product-handle');
    var siblings;
    if (!handle) return;
    siblings = mount.getAttribute('data-sibling-handles') || '';

    apiFetch(handle, siblings, function(data) {
      if (!data) {
        console.error('[shoppable] product mount request failed');
        return;
      }
      if (!data.videos || !data.videos.length) return;

      var shown = [];
      var fragment = document.createDocumentFragment();
      var i;
      var tile;

      for (i = 0; i < data.videos.length; i++) {
        tile = buildTile(data.videos[i]);
        if (!tile) continue;
        (function(idx, list, productHandle) {
          tile.addEventListener('click', function() {
            openFeed(list, idx, productHandle);
          });
        })(shown.length, shown, handle);
        shown.push(data.videos[i]);
        fragment.appendChild(tile);
      }

      if (fragment.childNodes.length) {
        mount.appendChild(fragment);
        ensureFeed();
      }
    });
  }

  function markWatchShopPopulated(mount) {
    var el = mount;
    var cn;
    while (el && el !== document.body) {
      cn = ' ' + (el.className || '') + ' ';
      if (cn.indexOf(' watch-shop ') !== -1) {
        if (cn.indexOf(' is-populated ') === -1) {
          el.className += ' is-populated';
        }
        return;
      }
      el = el.parentNode;
    }
  }

  function fillHomeMount(mount) {
    var tileCount = parseInt(mount.getAttribute('data-tile-count'), 10);
    var moreLabel = mount.getAttribute('data-more-label') || 'Shop More';
    if (!tileCount || tileCount < 1) tileCount = 5;

    apiFetchFeed(function(data) {
      var videos;
      var fragment;
      var i;
      var tile;
      var lastTile;
      var overlay;
      if (!data) {
        console.error('[shoppable] home mount request failed');
        return;
      }
      if (!data.videos || !data.videos.length) return;
      videos = data.videos;
      fragment = document.createDocumentFragment();
      lastTile = null;

      for (i = 0; i < tileCount && i < videos.length; i++) {
        tile = buildTile(videos[i]);
        if (!tile) continue;
        (function(idx, list) {
          tile.addEventListener('click', function() {
            openFeed(list, idx, '');
          });
        })(i, videos);
        fragment.appendChild(tile);
        lastTile = tile;
      }

      if (!fragment.childNodes.length) return;

      if (videos.length > tileCount && lastTile) {
        overlay = document.createElement('span');
        overlay.className = 'shoppable-more-overlay';
        overlay.appendChild(document.createTextNode(moreLabel));
        lastTile.appendChild(overlay);
      }

      mount.appendChild(fragment);
      ensureFeed();
      markWatchShopPopulated(mount);
    });
  }

  // ==================== FEED ====================
  var feedBuilt = false;
  var overlay, container, progressBar, muteBtn, navEl, productBar, productScroll, pauseIndicator;
  var slideEls = [];
  var videoEls = [];
  var loaderEls = [];
  var slideAssignments = [];

  var feedVideos = [];
  var currentHandle = '';
  var currentIndex = 0;
  var consecutiveSkipCount = 0;
  var isMuted = true;
  var isPaused = false;
  var isOpen = false;
  var savedScrollY = 0;
  var autoTimer = null;
  var settleTimer = null;
  var rafId = null;
  var progressMode = 'video';
  var timedDuration = 0;
  var timedElapsed = 0;
  var timedTickStart = 0;
  var pendingAdvance = null;
  var longPressPaused = false;

  function getSlotForIndex(vidIndex) {
    return ((vidIndex % SLIDE_COUNT) + SLIDE_COUNT) % SLIDE_COUNT;
  }

  function unloadVideo(vid) {
    if (!vid) return;
    try { vid.pause(); } catch(e) {}
    if (vid.src) {
      vid.removeAttribute('src');
      vid.removeAttribute('data-src-set');
      try { vid.load(); } catch(e) {}
    }
  }

  function clearMediaTimers() {
    if (autoTimer) { clearTimeout(autoTimer); autoTimer = null; }
    if (settleTimer) { clearTimeout(settleTimer); settleTimer = null; }
    if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
    pendingAdvance = null;
  }

  function lockScroll() {
    savedScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + savedScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }

  function unlockScroll() {
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    if (window.scrollTo) window.scrollTo(0, savedScrollY);
  }

  function setPausedVisible(on) {
    if (!pauseIndicator) return;
    if (on) {
      if (pauseIndicator.className.indexOf('visible') === -1) {
        pauseIndicator.className += ' visible';
      }
    } else {
      pauseIndicator.className = pauseIndicator.className.replace(/\s*visible/g, '');
    }
  }

  function stopProgress() {
    if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
  }

  function startVideoProgress() {
    stopProgress();
    progressMode = 'video';
    (function tick() {
      if (!isOpen || isPaused) return;
      var slot = getSlotForIndex(currentIndex);
      var v = videoEls[slot];
      if (v && v.duration && isFinite(v.duration) && v.duration > 0) {
        progressBar.style.width = (v.currentTime / v.duration * 100) + '%';
      }
      rafId = requestAnimationFrame(tick);
    })();
  }

  function startTimedProgress(durationMs, alreadyElapsed) {
    stopProgress();
    progressMode = 'timed';
    timedDuration = durationMs;
    timedElapsed = alreadyElapsed || 0;
    timedTickStart = Date.now();
    (function tick() {
      if (!isOpen || isPaused) return;
      var elapsed = timedElapsed + (Date.now() - timedTickStart);
      var pct = timedDuration ? Math.min(100, (elapsed / timedDuration) * 100) : 0;
      progressBar.style.width = pct + '%';
      rafId = requestAnimationFrame(tick);
    })();
  }

  function pauseTimedProgress() {
    if (progressMode === 'timed' && timedTickStart) {
      timedElapsed += Date.now() - timedTickStart;
    }
    stopProgress();
  }

  function assignSlide(vidIndex) {
    if (vidIndex < 0 || vidIndex >= feedVideos.length) return -1;
    var slot = getSlotForIndex(vidIndex);
    var slide = slideEls[slot];
    var vid = videoEls[slot];
    var loader = loaderEls[slot];
    var item = feedVideos[vidIndex];
    var poster = resolveThumbnail(item);

    if (slideAssignments[slot] === vidIndex) return slot;

    unloadVideo(vid);
    slideAssignments[slot] = vidIndex;

    if (poster) {
      slide.style.backgroundImage = 'url(' + poster + ')';
    } else {
      slide.style.backgroundImage = '';
    }

    loader.style.display = 'flex';
    return slot;
  }

  function loadSlotMedia(vidIndex) {
    if (vidIndex < 0 || vidIndex >= feedVideos.length) return;
    var slot = assignSlide(vidIndex);
    if (slot === -1) return;

    var item = feedVideos[vidIndex];
    var type = item.media_type || 'video';
    var slide = slideEls[slot];
    var vid = videoEls[slot];
    var loader = loaderEls[slot];
    var poster = resolveThumbnail(item);
    var src;

    if (type === 'video' && !item.bunny_url) {
      console.error('[shoppable] video missing bunny_url', vidIndex, item.id, item.title);
    }

    if (type === 'video' && item.bunny_url) {
      if (poster) {
        slide.style.backgroundImage = 'url(' + poster + ')';
        vid.setAttribute('poster', poster);
      } else {
        slide.style.backgroundImage = '';
        vid.removeAttribute('poster');
      }
      if (vid.getAttribute('data-src-set') !== item.bunny_url) {
        vid.src = item.bunny_url;
        vid.setAttribute('data-src-set', item.bunny_url);
        vid.preload = 'auto';
        try { vid.load(); } catch(e) {}
      }
    } else {
      unloadVideo(vid);
      if (type === 'carousel' && item.media_items && item.media_items.length) {
        src = item.media_items[0].url || item.media_items[0].thumbnail_url || poster;
      } else {
        src = item.image_url || poster;
      }
      if (src) {
        slide.style.backgroundImage = 'url(' + src + ')';
      }
      loader.style.display = 'none';
    }
  }

  function positionSlides() {
    var offsets = [0, -1, 1];
    var oi;
    var offset;
    var vidIndex;
    var slot;
    var used = [];
    var i;
    var len = feedVideos.length;

    for (oi = 0; oi < offsets.length; oi++) {
      offset = offsets[oi];
      vidIndex = currentIndex + offset;
      if (vidIndex < 0 || vidIndex >= len) {
        if (len > SLIDE_COUNT) {
          vidIndex = ((vidIndex % len) + len) % len;
          if (used[getSlotForIndex(vidIndex)]) continue;
        } else {
          continue;
        }
      }
      slot = getSlotForIndex(vidIndex);
      if (used[slot]) continue;
      slot = assignSlide(vidIndex);
      if (slot === -1) continue;
      used[slot] = 1;
      slideEls[slot].style.transition = 'none';
      slideEls[slot].style.transform = 'translateY(' + (offset * 100) + '%)';
    }

    for (i = 0; i < SLIDE_COUNT; i++) {
      if (!used[i]) {
        slideEls[i].style.transition = 'none';
        slideEls[i].style.transform = 'translateY(300%)';
      }
    }
  }

  function showCarouselFrame(pos) {
    var item = feedVideos[currentIndex];
    if (!item || !item.media_items || !item.media_items.length) return;
    if (pos < 0 || pos >= item.media_items.length) return;

    var slot = getSlotForIndex(currentIndex);
    var loader = loaderEls[slot];
    var frame = item.media_items[pos];
    var src = (frame && (frame.url || frame.thumbnail_url)) || '';

    if (src) {
      slideEls[slot].style.backgroundImage = 'url(' + src + ')';
    }
    loader.style.display = 'none';
    startTimedProgress(CAROUSEL_MS, 0);
    scheduleAdvance(CAROUSEL_MS, function() {
      if (pos + 1 < item.media_items.length) {
        showCarouselFrame(pos + 1);
      } else {
        goTo(currentIndex + 1);
      }
    });
  }

  function scheduleAdvance(ms, fn) {
    if (autoTimer) { clearTimeout(autoTimer); autoTimer = null; }
    pendingAdvance = { remaining: ms, fn: fn };
    if (isPaused) return;
    autoTimer = setTimeout(function() {
      autoTimer = null;
      pendingAdvance = null;
      if (!isOpen || isPaused) return;
      fn();
    }, ms);
  }

  function skipBrokenItem(reason) {
    var item = feedVideos[currentIndex];
    consecutiveSkipCount += 1;
    console.error(
      '[shoppable] skipBrokenItem',
      reason,
      currentIndex,
      item ? item.bunny_url : '',
      item ? item.id : ''
    );
    if (consecutiveSkipCount > 5) {
      consecutiveSkipCount = 0;
      closeFeed();
      return;
    } else if (feedVideos.length === 1) {
      consecutiveSkipCount = 0;
      closeFeed();
      return;
    } else {
      goTo(currentIndex + 1);
    }
  }

  function playCurrentItem() {
    var item = feedVideos[currentIndex];
    if (!item) return;
    var type = item.media_type || 'video';
    var slot = getSlotForIndex(currentIndex);
    var v = videoEls[slot];
    var i;

    isPaused = false;
    longPressPaused = false;
    setPausedVisible(false);
    progressBar.style.width = '0%';

    if (autoTimer) { clearTimeout(autoTimer); autoTimer = null; }
    pendingAdvance = null;

    for (i = 0; i < videoEls.length; i++) {
      if (i !== slot) try { videoEls[i].pause(); } catch(e) {}
    }

    if (type === 'image') {
      startTimedProgress(IMAGE_MS, 0);
      scheduleAdvance(IMAGE_MS, function() { goTo(currentIndex + 1); });
    } else if (type === 'carousel') {
      if (item.media_items && item.media_items.length) {
        showCarouselFrame(0);
      } else {
        startTimedProgress(IMAGE_MS, 0);
        scheduleAdvance(IMAGE_MS, function() { goTo(currentIndex + 1); });
      }
    } else if ((item.media_type || 'video') === 'video' && item.bunny_url && v) {
      if (slideAssignments[slot] !== currentIndex) {
        updateProductCard();
        return;
      }
      v.muted = isMuted;
      try { v.currentTime = 0; } catch(e) {}
      try {
        var p = v.play();
        if (p && p.catch) {
          p.catch(function(err) {
            if (err && err.name === 'NotSupportedError') {
              skipBrokenItem('play rejected: NotSupportedError');
              return;
            }
            v.muted = true;
            muteBtn.innerHTML = ICONS.muted;
            try {
              v.play();
              setTimeout(function() {
                if (!isMuted && !isPaused && isOpen) {
                  v.muted = false;
                  muteBtn.innerHTML = ICONS.unmuted;
                }
              }, 800);
            } catch(e) {}
          });
        }
      } catch(e) {}
      startVideoProgress();
    } else {
      startTimedProgress(IMAGE_MS, 0);
      scheduleAdvance(IMAGE_MS, function() { goTo(currentIndex + 1); });
    }

    updateProductCard();
  }

  function updateProductCard() {
    var item = feedVideos[currentIndex];
    var prods = (item && item.video_products) || [];
    var visibleProds = [];
    var i;
    var p;
    var card;
    var html;
    var link;

    productScroll.innerHTML = '';

    for (i = 0; i < prods.length; i++) {
      if (prods[i].product_handle === currentHandle) continue;
      if (prods[i].product_available === false) continue;
      visibleProds.push(prods[i]);
    }

    if (!visibleProds.length) {
      productBar.style.display = 'none';
      return;
    }
    productBar.style.display = '';

    for (i = 0; i < visibleProds.length; i++) {
      p = visibleProds[i];
      card = document.createElement('div');
      card.className = 'sf-product-card';
      html = '<div class="sf-pc-title">' + (p.product_title || p.product_handle).replace(/</g, '&lt;') + '</div>';
      html += '<a class="sf-pc-btn" href="/products/' + p.product_handle + '" target="_blank" rel="noopener">View</a>';
      card.innerHTML = html;
      link = card.querySelector('.sf-pc-btn');
      if (link) {
        link.addEventListener('click', function() {
          var slot = getSlotForIndex(currentIndex);
          try { videoEls[slot].pause(); } catch(e) {}
        });
      }
      productScroll.appendChild(card);
    }
  }

  function goTo(index, animated) {
    var oldIndex = currentIndex;
    var direction;
    var currentSlot;
    var oldSlot;
    var transitionCSS;

    if (index < 0) index = feedVideos.length - 1;
    if (index >= feedVideos.length) index = 0;
    if (index === currentIndex) {
      currentSlot = getSlotForIndex(currentIndex);
      slideEls[currentSlot].style.transition = 'transform 0.3s ease';
      slideEls[currentSlot].style.transform = 'translateY(0)';
      return;
    }

    clearMediaTimers();
    progressBar.style.width = '0%';

    currentIndex = index;
    isPaused = false;
    longPressPaused = false;
    setPausedVisible(false);

    oldSlot = getSlotForIndex(oldIndex);
    try { videoEls[oldSlot].pause(); } catch(e) {}

    positionSlides();

    if (animated !== false) {
      direction = index > oldIndex ? -1 : 1;
      if (oldIndex === 0 && index === feedVideos.length - 1) direction = 1;
      if (oldIndex === feedVideos.length - 1 && index === 0) direction = -1;
      currentSlot = getSlotForIndex(currentIndex);
      oldSlot = getSlotForIndex(oldIndex);

      if (currentSlot === oldSlot) {
        slideEls[currentSlot].style.transition = 'none';
        slideEls[currentSlot].style.transform = 'translateY(0%)';
      } else {
        slideEls[currentSlot].style.transition = 'none';
        slideEls[currentSlot].style.transform = 'translateY(' + (-direction * 100) + '%)';
        slideEls[currentSlot].offsetHeight;

        slideEls[oldSlot].style.transition = 'none';
        slideEls[oldSlot].style.transform = 'translateY(0%)';
        slideEls[oldSlot].offsetHeight;

        transitionCSS = 'transform 0.4s cubic-bezier(0.16, 1, 0.3, 1)';
        slideEls[currentSlot].style.transition = transitionCSS;
        slideEls[currentSlot].style.transform = 'translateY(0%)';

        slideEls[oldSlot].style.transition = transitionCSS;
        slideEls[oldSlot].style.transform = 'translateY(' + (direction * 100) + '%)';
      }
    }

    if (settleTimer) clearTimeout(settleTimer);
    settleTimer = setTimeout(function() {
      loadSlotMedia(currentIndex);
      if (currentIndex > 0) loadSlotMedia(currentIndex - 1);
      if (currentIndex < feedVideos.length - 1) loadSlotMedia(currentIndex + 1);
      playCurrentItem();
    }, animated === false ? 0 : SETTLE_DELAY);
  }

  function pauseMedia() {
    var slot;
    var v;
    var remaining;
    if (isPaused) return;
    isPaused = true;
    setPausedVisible(true);
    slot = getSlotForIndex(currentIndex);
    v = videoEls[slot];
    if (v) try { v.pause(); } catch(e) {}
    if (autoTimer) { clearTimeout(autoTimer); autoTimer = null; }
    if (pendingAdvance) {
      remaining = pendingAdvance.remaining;
      if (progressMode === 'timed') {
        remaining = Math.max(0, timedDuration - (timedElapsed + (Date.now() - timedTickStart)));
        pendingAdvance.remaining = remaining;
      }
    }
    pauseTimedProgress();
  }

  function resumeMedia() {
    var slot;
    var v;
    var fn;
    var remaining;
    var item;
    if (!isPaused) return;
    isPaused = false;
    longPressPaused = false;
    setPausedVisible(false);
    slot = getSlotForIndex(currentIndex);
    v = videoEls[slot];
    item = feedVideos[currentIndex];
    if (item && (item.media_type || 'video') === 'video' && item.bunny_url) {
      if (v) {
        v.muted = isMuted;
        try { v.play(); } catch(e) {}
      }
      startVideoProgress();
    } else if (pendingAdvance) {
      remaining = pendingAdvance.remaining;
      fn = pendingAdvance.fn;
      startTimedProgress(timedDuration, timedDuration - remaining);
      scheduleAdvance(remaining, fn);
    }
  }

  function togglePause() {
    if (isPaused) resumeMedia();
    else pauseMedia();
  }

  function toggleMute() {
    var i;
    isMuted = !isMuted;
    for (i = 0; i < videoEls.length; i++) videoEls[i].muted = isMuted;
    muteBtn.innerHTML = isMuted ? ICONS.muted : ICONS.unmuted;
    muteBtn.setAttribute('aria-label', isMuted ? 'Unmute' : 'Mute');
    try { sessionStorage.setItem('sf-muted', isMuted ? '1' : '0'); } catch(e) {}
  }

  function closeFeed() {
    var i;
    if (!isOpen) return;
    isOpen = false;
    overlay.className = overlay.className.replace(/\s*active/g, '');
    unlockScroll();
    clearMediaTimers();
    stopProgress();
    progressBar.style.width = '0%';
    isPaused = false;
    longPressPaused = false;
    setPausedVisible(false);
    for (i = 0; i < videoEls.length; i++) {
      try { videoEls[i].pause(); } catch(e) {}
    }
  }

  function openFeed(videos, index, handle) {
    if (!videos || !videos.length) return;
    ensureFeed();

    feedVideos = videos;
    currentHandle = handle || '';
    currentIndex = index || 0;
    if (currentIndex < 0) currentIndex = 0;
    if (currentIndex >= feedVideos.length) currentIndex = 0;
    isPaused = false;
    longPressPaused = false;
    isOpen = true;

    try { if (sessionStorage.getItem('sf-muted') === '0') isMuted = false; } catch(e) {}
    muteBtn.innerHTML = isMuted ? ICONS.muted : ICONS.unmuted;
    muteBtn.setAttribute('aria-label', isMuted ? 'Unmute' : 'Mute');

    if (feedVideos.length > 1) navEl.style.display = '';
    else navEl.style.display = 'none';

    var s;
    for (s = 0; s < SLIDE_COUNT; s++) slideAssignments[s] = -1;

    overlay.className += overlay.className.indexOf('active') === -1 ? ' active' : '';
    lockScroll();
    positionSlides();
    loadSlotMedia(currentIndex);
    if (currentIndex > 0) loadSlotMedia(currentIndex - 1);
    if (currentIndex < feedVideos.length - 1) loadSlotMedia(currentIndex + 1);
    playCurrentItem();
  }

  function isControl(el) {
    var cn;
    while (el && el !== container) {
      cn = el.className || '';
      if (typeof cn !== 'string') cn = '';
      if (cn.indexOf('sf-product-bar') !== -1 || cn.indexOf('sf-nav') !== -1) return true;
      if (cn.indexOf('sf-ctrl') !== -1 || cn.indexOf('sf-nav-btn') !== -1 || cn.indexOf('sf-pc-btn') !== -1) return true;
      el = el.parentNode;
    }
    return false;
  }

  function ensureFeed() {
    if (feedBuilt) return;
    feedBuilt = true;

    var i;
    var slide;
    var video;
    var gradTop;
    var gradBot;
    var loader;
    var progressWrap;
    var closeBtn;
    var prevBtn;
    var nextBtn;
    var touchStartY = 0;
    var touchStartTime = 0;
    var touchDelta = 0;
    var isSwiping = false;
    var longPressTimer = null;
    var isLongPress = false;
    var tapStartTime = 0;
    var touchUsed = false;
    var wheelLock = false;

    overlay = document.createElement('div');
    overlay.className = 'sf-overlay';

    container = document.createElement('div');
    container.className = 'sf-container';

    progressWrap = document.createElement('div');
    progressWrap.className = 'sf-progress-wrap';
    progressBar = document.createElement('div');
    progressBar.className = 'sf-progress-bar';
    progressWrap.appendChild(progressBar);
    container.appendChild(progressWrap);

    for (i = 0; i < SLIDE_COUNT; i++) {
      slide = document.createElement('div');
      slide.className = 'sf-slide';

      video = document.createElement('video');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('loop', '');
      video.setAttribute('preload', 'none');
      video.muted = true;
      video.playsInline = true;

      gradTop = document.createElement('div');
      gradTop.className = 'sf-grad-top';
      gradBot = document.createElement('div');
      gradBot.className = 'sf-grad-bot';

      loader = document.createElement('div');
      loader.className = 'sf-loading';
      loader.innerHTML = '<div class="sf-spinner"></div>';

      slide.appendChild(video);
      slide.appendChild(gradTop);
      slide.appendChild(gradBot);
      slide.appendChild(loader);
      container.appendChild(slide);

      slideEls.push(slide);
      videoEls.push(video);
      loaderEls.push(loader);
      slideAssignments.push(-1);

      (function(v, l, slotIndex) {
        v.addEventListener('canplay', function() { l.style.display = 'none'; });
        v.addEventListener('waiting', function() { l.style.display = 'flex'; });
        v.addEventListener('playing', function() {
          l.style.display = 'none';
          consecutiveSkipCount = 0;
        });
        v.addEventListener('error', function() {
          l.style.display = 'none';
          if (getSlotForIndex(currentIndex) === slotIndex) {
            skipBrokenItem('video element error event');
          }
        });
      })(video, loader, i);
    }

    closeBtn = document.createElement('button');
    closeBtn.className = 'sf-ctrl sf-close';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.innerHTML = ICONS.close;
    container.appendChild(closeBtn);

    muteBtn = document.createElement('button');
    muteBtn.className = 'sf-ctrl sf-mute';
    muteBtn.setAttribute('aria-label', 'Unmute');
    muteBtn.innerHTML = ICONS.muted;
    container.appendChild(muteBtn);

    navEl = document.createElement('div');
    navEl.className = 'sf-nav';
    prevBtn = document.createElement('button');
    prevBtn.className = 'sf-nav-btn';
    prevBtn.setAttribute('aria-label', 'Previous');
    prevBtn.innerHTML = ICONS.chevUp;
    nextBtn = document.createElement('button');
    nextBtn.className = 'sf-nav-btn';
    nextBtn.setAttribute('aria-label', 'Next');
    nextBtn.innerHTML = ICONS.chevDown;
    navEl.appendChild(prevBtn);
    navEl.appendChild(nextBtn);
    container.appendChild(navEl);

    productBar = document.createElement('div');
    productBar.className = 'sf-product-bar';
    productScroll = document.createElement('div');
    productScroll.className = 'sf-product-scroll';
    productBar.appendChild(productScroll);
    container.appendChild(productBar);

    pauseIndicator = document.createElement('div');
    pauseIndicator.className = 'sf-pause-ind';
    pauseIndicator.innerHTML = ICONS.pauseBig;
    container.appendChild(pauseIndicator);

    overlay.appendChild(container);
    document.body.appendChild(overlay);

    closeBtn.addEventListener('click', function(e) { e.stopPropagation(); closeFeed(); });
    overlay.addEventListener('click', function(e) { if (e.target === overlay) closeFeed(); });
    muteBtn.addEventListener('click', function(e) { e.stopPropagation(); toggleMute(); });
    prevBtn.addEventListener('click', function(e) { e.stopPropagation(); goTo(currentIndex - 1); });
    nextBtn.addEventListener('click', function(e) { e.stopPropagation(); goTo(currentIndex + 1); });

    container.addEventListener('touchstart', function(e) {
      if (isControl(e.target)) return;
      touchStartY = e.touches[0].clientY;
      touchStartTime = Date.now();
      tapStartTime = Date.now();
      touchDelta = 0;
      isSwiping = true;
      isLongPress = false;
      longPressPaused = false;
      if (longPressTimer) clearTimeout(longPressTimer);
      longPressTimer = setTimeout(function() {
        isLongPress = true;
        if (!isPaused) {
          longPressPaused = true;
          pauseMedia();
        }
      }, LONG_PRESS_MS);
    }, { passive: true });

    container.addEventListener('touchmove', function(e) {
      var currentSlot;
      var delta;
      var h;
      var nextSlot;
      var prevSlot;
      if (!isSwiping) return;
      touchDelta = e.touches[0].clientY - touchStartY;
      if (Math.abs(touchDelta) > 10) {
        if (longPressTimer) clearTimeout(longPressTimer);
        if (isLongPress && longPressPaused) {
          isLongPress = false;
          longPressPaused = false;
          resumeMedia();
        }
      }
      currentSlot = getSlotForIndex(currentIndex);
      delta = touchDelta;
      if (currentIndex === 0 && delta > 0) delta = delta * 0.3;
      h = container.offsetHeight || window.innerHeight;
      slideEls[currentSlot].style.transition = 'none';
      slideEls[currentSlot].style.transform = 'translateY(' + delta + 'px)';
      if (delta < 0 && currentIndex < feedVideos.length - 1) {
        nextSlot = getSlotForIndex(currentIndex + 1);
        assignSlide(currentIndex + 1);
        slideEls[nextSlot].style.transition = 'none';
        slideEls[nextSlot].style.transform = 'translateY(' + (h + delta) + 'px)';
      } else if (delta > 0 && currentIndex > 0) {
        prevSlot = getSlotForIndex(currentIndex - 1);
        assignSlide(currentIndex - 1);
        slideEls[prevSlot].style.transition = 'none';
        slideEls[prevSlot].style.transform = 'translateY(' + (-h + delta) + 'px)';
      }
    }, { passive: true });

    container.addEventListener('touchend', function() {
      var elapsed;
      var velocity;
      var newIndex;
      var currentSlot;
      if (longPressTimer) clearTimeout(longPressTimer);
      if (!isSwiping) return;
      isSwiping = false;
      elapsed = Date.now() - touchStartTime;
      velocity = Math.abs(touchDelta) / Math.max(elapsed, 1);

      if (isLongPress && longPressPaused) {
        isLongPress = false;
        longPressPaused = false;
        resumeMedia();
        touchUsed = true;
        return;
      }

      if (currentIndex === 0 && touchDelta > 80) {
        closeFeed();
        touchUsed = true;
        return;
      }

      if (feedVideos.length === 1 && (touchDelta < -50 || (touchDelta < -20 && velocity > 0.3))) {
        touchUsed = true;
        closeFeed();
        return;
      }

      newIndex = currentIndex;
      if (touchDelta < -50 || (touchDelta < -20 && velocity > 0.3)) {
        newIndex = currentIndex + 1;
      } else if (touchDelta > 50 || (touchDelta > 20 && velocity > 0.3)) {
        newIndex = currentIndex - 1;
      }

      if (newIndex === currentIndex) {
        currentSlot = getSlotForIndex(currentIndex);
        slideEls[currentSlot].style.transition = 'transform 0.3s ease';
        slideEls[currentSlot].style.transform = 'translateY(0)';
        if (elapsed < 200 && Math.abs(touchDelta) < 10 && !isLongPress) {
          touchUsed = true;
          togglePause();
        }
        return;
      }

      touchUsed = true;
      goTo(newIndex);
    }, { passive: true });

    container.addEventListener('click', function(e) {
      if (isControl(e.target)) return;
      if (touchUsed) { touchUsed = false; return; }
      togglePause();
    });

    overlay.addEventListener('wheel', function(e) {
      if (!isOpen || wheelLock) return;
      if (e.preventDefault) e.preventDefault();
      wheelLock = true;
      if (e.deltaY > 30) goTo(currentIndex + 1);
      else if (e.deltaY < -30) goTo(currentIndex - 1);
      setTimeout(function() { wheelLock = false; }, WHEEL_THROTTLE_MS);
    }, false);

    document.addEventListener('keydown', function(e) {
      if (!isOpen) return;
      if (e.key === 'Escape' || e.keyCode === 27) closeFeed();
      else if (e.key === 'ArrowDown' || e.keyCode === 40 || e.key === 'ArrowRight' || e.keyCode === 39) { e.preventDefault(); goTo(currentIndex + 1); }
      else if (e.key === 'ArrowUp' || e.keyCode === 38 || e.key === 'ArrowLeft' || e.keyCode === 37) { e.preventDefault(); goTo(currentIndex - 1); }
      else if (e.key === ' ' || e.keyCode === 32) { e.preventDefault(); togglePause(); }
    });
  }

  // ==================== INIT ====================
  function init() {
    var mounts = document.querySelectorAll('[data-shoppable-row]');
    var homeMounts = document.querySelectorAll('[data-shoppable-home]');
    var m;
    for (m = 0; m < mounts.length; m++) {
      fillMount(mounts[m]);
    }
    for (m = 0; m < homeMounts.length; m++) {
      fillHomeMount(homeMounts[m]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
